/* Copyright (c) 2023-2026, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FocusManager } from '../../services/focus-manager';
import { NvHigFullPageDialogComponent } from './nv-hig-fullpage-dialog.component';
import { NvHigFullPageDialogData, OpenFullPageDialogOptions } from './nv-hig-fullpage-dialog.types';

@Injectable({
    providedIn: 'root'
})
export class NvHigFullPageDialog {
    constructor(
        private matDialog: MatDialog,
        private focusManager: FocusManager,
        private translateService: TranslateService
    ) {}

    public open<T>(
        data: NvHigFullPageDialogData<T>,
        options?: OpenFullPageDialogOptions
    ): MatDialogRef<NvHigFullPageDialogComponent<T>> {
        // autoFocus is true by default in MatDialogConfig
        // set autoFocus to false to avoid conflicting with nvAutoFocus
        return this.focusManager.restoreFocusAfterClosed(
            () =>
                this.matDialog.open<NvHigFullPageDialogComponent<T>>(NvHigFullPageDialogComponent, {
                    data,
                    autoFocus: false,
                    ariaLabel: this.translateService.instant(data.title.text),
                    maxWidth: '100vw',
                    panelClass: 'dialogPaddingRemove',
                    height: '100%',
                    width: '100%'
                }),
            options
        );
    }
}
